import { where } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import helpers from '../../../../../commonHelpers/helpers'
import { CONST } from '../../../../../const/const'
import { MESSAGES_CONST } from '../../../../../const/messages-const'
import { CustomError, getUserFullName } from '../../../../../helpers/helpers'
import {
  IFeesTab,
  IRegistrationTabs,
  TEventRegisteredUsers,
} from '../../../../../models/event-registered-users/event-registered-users.interface'
import { EventRegisteredUsersModel } from '../../../../../models/event-registered-users/event-registered-users.model'
import { IEventReviewPublish } from '../../../../../models/event-review-publish/event-review-publish.interface'
import { EventReviewPublishModel } from '../../../../../models/event-review-publish/event-review-publish.model'
import { getConvertedData } from '../../../../../models/interface.helper'
import { IRegistrationFeesInterface } from '../../../../../models/registration-fees/registrationFees.interface'
import { IRegistrationTicketInterface } from '../../../../../models/registration-tickets/registrationTicket.interface'
import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'
import { RegistrationByDayModel } from '../../../../../models/registrations-by-day/registrationByDay.model'
import { IUserInterface } from '../../../../../models/users/user.interface'
import { UserModel } from '../../../../../models/users/user.model'
import FirestoreService from '../../../../../services/firestoreService'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'

import ITypes from '../useEventRegistrationTabs.types'

import fakeDocumentList from '../../../../../fakeData/fakeDocumentList'
import { RegistrationFeesType } from '../../../../../models/event-fees/event-fees.interface'
import { IRecipientInterface } from '../../../../../models/recipients/recipients.interface'
import { ISelectedEvent } from '../../../../../store/events/eventsSlice'

import { IRiderTeamMemberInterface } from '../../../../../models/rider-team-member/riderTeamMember.interface'
import {
  selectPublishedEventInDb,
  selectRegistration,
  selectTeamTabData,
  setFeesTabDataAc,
  setFilteredPaperworkDocuments,
  setPaperworkTabData,
  setPublishedEventInDb,
  setRecipientsInDb,
  setRegisterTabData,
  setRegistrationAc,
  setRegistrationLoading,
  setRegistrationsByDay,
  setRegistrationsByDayInDb,
  setRegistrationsFeesAc,
  setRegistrationsTicketsAc,
  setRidersTeamMembers,
  setRidersTeamMembersInDb,
  setTicketTabData,
} from '../../../../../store/registration/registrationSlice'
import UserService from '../../../../../services/firebase-service/users/userService'
import RecipientsService from '../../../../../services/firebase-service/recipients/RecipientsService'

import { getFilteredPaperwork } from '../../../../../helpers/documents'
import {
  getRiderTeamMembersFromDb,
  mergeRidersTeamMembersWithPaperworkTabData,
} from '../../../../../helpers/teamMembers'
import { selectHorses } from '../../../../../store/horses/horseSlice'
import { mergeRegistrationWithTabData } from '../../../../../helpers/registration-on-event'
import { mergeFeesWithTabData } from '../../../../../helpers/registrationFees'
import { mergeTicketsWithTabData } from '../../../../../helpers/tickets'
import useTeamMembers from '../../../../../hooks/useTeamMembers'
import { getFeesTabData } from '../../../../../helpers/fees'

// Constants
const FILE_NAME = 'useEventRegistrationTabs'
const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS
const customErrorProps = {
  fileName: FILE_NAME,
  message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
}

export interface IOnChangeFees {
  currentRow: IFeesTab
  selectedCount: number
  publishedEvent: ISelectedEvent
}

const useEventRegistrationTabs = () => {
  const dispatch = useAppDispatch()

  const { getPaperworkTabData } = useTeamMembers()

  const myHorses = useAppSelector(selectHorses)
  const registration = useAppSelector(selectRegistration)
  const publishedEventInDb = useAppSelector(selectPublishedEventInDb)
  const teamMembers = useAppSelector(selectTeamTabData)

  const { eventId, userId } = useParams<ITypes['IParams']>()

  const [registeredUser, setRegisteredUser] = useState<IUserInterface | null>(null)

  useEffect(() => {
    const getCurrentUser = async () => {
      const userSnaps = await UserService.getUserInfoById(userId)
      const user = UserModel.fromFirestoreDoc(userSnaps).toObject()
      setRegisteredUser(user)
    }

    if (userId) getCurrentUser().then()
  }, [userId])

  useEffect(() => {
    if (!eventId || !userId || !registeredUser) return

    async function loadAll() {
      dispatch(setRegistrationLoading(true))

      let registrationId: string | null = null
      let registrationInDb: null | TEventRegisteredUsers = null

      let publishedEventInDb_: IEventReviewPublish | null = null
      let recipientsInDb: IRecipientInterface[] = []
      let registrationsByDayFromDb: IRegistrationByDayInterface[] = []
      let ridersTeamMembersInDb: IRiderTeamMemberInterface[] = []

      let registrationByDay_: IRegistrationByDayInterface[] = []
      let registrationFees_: IRegistrationFeesInterface[] = []
      let registrationTickets_: IRegistrationTicketInterface[] = []
      let ridersTeamMembers_: IRiderTeamMemberInterface[] = []

      let registerTabData_: IRegistrationTabs['IRegisterTab'][] = []
      let ticketTabData_: IRegistrationTabs['ITicketTab'][] = []
      let feesTabData_: IRegistrationTabs['IFeesTab'][] = []

      let filteredPaperworkDocuments: typeof fakeDocumentList = []

      try {
        publishedEventInDb_ = await getPublishedEventFromDb()

        registrationInDb = await getRegistrationFromDb()
        registrationId = registrationInDb?.id ?? null

        if (registrationId) {
          registrationByDay_ = registrationInDb?.cartItems?.classes || []
          registrationFees_ = registrationInDb?.cartItems?.fees || []
          registrationTickets_ = registrationInDb?.cartItems?.tickets || []
          ridersTeamMembers_ = registrationInDb?.cartItems?.ridersTeamMembers || []
          ;[registrationsByDayFromDb, ridersTeamMembersInDb, recipientsInDb] = await Promise.all([
            getRegistrationsByDayFromDb(registrationId),
            getRiderTeamMembersFromDb(registrationId),
            RecipientsService.getByRecipientsByEvent(eventId, userId),
          ])
        }

        registerTabData_ = getRegisterTabData(publishedEventInDb_)
        registerTabData_ = mergeRegistrationWithTabData(registerTabData_, registrationByDay_)

        feesTabData_ = getFeesTabData(publishedEventInDb_)
        feesTabData_ = mergeFeesWithTabData({
          feesTabData: feesTabData_,
          registrationFees: registrationFees_,
        })

        ticketTabData_ = getTicketTabData(publishedEventInDb_)
        ticketTabData_ = mergeTicketsWithTabData(ticketTabData_, registrationTickets_)

        const { paperworkTabDataUnique } = getPaperworkTabData(
          registrationByDay_,
          ridersTeamMembers_
        )
        const paperworkTabDataUpdated = mergeRidersTeamMembersWithPaperworkTabData({
          paperworkTabData: paperworkTabDataUnique,
          ridersTeamMembers: ridersTeamMembers_,
        })

        filteredPaperworkDocuments = getFilteredPaperwork(
          publishedEventInDb_?.EventPaperwork ?? null
        )

        dispatch(setRegistrationAc(registrationInDb))

        dispatch(setPublishedEventInDb(publishedEventInDb_))
        dispatch(setRecipientsInDb(recipientsInDb))
        dispatch(setRidersTeamMembersInDb(ridersTeamMembersInDb))
        dispatch(setRegistrationsByDayInDb(registrationsByDayFromDb))

        dispatch(setRegisterTabData(registerTabData_))
        dispatch(setRegistrationsByDay(registrationByDay_))

        dispatch(setFeesTabDataAc(feesTabData_))
        dispatch(setRegistrationsFeesAc(registrationFees_))

        dispatch(setTicketTabData(ticketTabData_))
        dispatch(setRegistrationsTicketsAc(registrationTickets_))

        dispatch(setPaperworkTabData(paperworkTabDataUpdated))
        dispatch(setRidersTeamMembers(ridersTeamMembers_))

        dispatch(setFilteredPaperworkDocuments(filteredPaperworkDocuments))
      } catch (error) {
        console.error(error, 'error')
      } finally {
        dispatch(setRegistrationLoading(false))
      }
    }
    loadAll().then()
  }, [eventId, userId, registeredUser, registration?.id])

  function getBasicQueries() {
    const { EVENT_ID, USER_ID } = COLLECTIONS.EVENT_REGISTERED_USERS.FIELDS
    return [where(USER_ID.KEY, '==', userId), where(EVENT_ID.KEY, '==', eventId)]
  }

  const createRegistration = async () => {
    let EventDetails = publishedEventInDb?.EventDetails ?? null

    try {
      const horsesIds = myHorses.map((horse) => `${horse.id}`)
      const membersIds = teamMembers
        .filter((member) => member.memberId !== userId)
        .map((member) => `${member.memberId}`)

      if (registration?.id) {
        await FirestoreService.updateItem(
          COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
          registration.id,
          {
            horsesIds,
            membersIds,
            modified: new Date().toString(),
          }
        )
      } else if (registeredUser?.id) {
        await FirestoreService.createItem(
          COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
          new EventRegisteredUsersModel({
            ...registeredUser,
            horsesIds,
            membersIds,
            eventId,
            eventName: EventDetails?.competitionName,
            eventLogo: EventDetails?.eventLogo,
            userId,
            userName: registeredUser ? getUserFullName(registeredUser) : null,
          }).toFirestore()
        )
      } else {
        console.error('Current registration not found')
        return null
      }

      const registrationInDb = await getRegistrationFromDb()
      dispatch(setRegistrationAc(registrationInDb))
      return registrationInDb
    } catch (error) {
      console.error(error, 'error')
      return null
    }
  }

  function getRegisterTabData(publishedEventInDb_: IEventReviewPublish | null) {
    let registerTabData_: IRegistrationTabs['IRegisterTab'][] = []
    let registrationFees_: RegistrationFeesType[] = []
    try {
      if (publishedEventInDb_) {
        const { EventFees } = publishedEventInDb_
        if ('registrationFees' in EventFees) {
          const { registrationFees } = EventFees
          if (registrationFees && registrationFees.length) {
            registrationFees_ = registrationFees
          }
        }
      }

      registrationFees_.forEach((fees) => {
        registerTabData_.push({
          feesNote: fees.note,
          registrationsByDay: [],
          price: fees.cost,
          startDate: fees.startDate,
          startTimeHours: fees.startTimeHours,
          startTimeMinutes: fees.startTimeMinutes,
          startTimeFormat: fees.startTimeFormat,
          registrationByDayName: fees.name ? (fees.name === '' ? 'Custom' : fees.name) : 'Custom',
          uuid: fees.uuid,
          order: fees.order,
          qualifyFee: fees.qualifyingClass?.price ?? null,
          qualifyFeeName: fees.qualifyingClass?.name || null,
          children:
            fees.children?.map((children) => ({
              feesNote: children.note,
              registrationsByDay: [],
              price: children.cost,
              startDate: children.startDate,
              startTimeHours: children.startTimeHours,
              startTimeMinutes: children.startTimeMinutes,
              startTimeFormat: children.startTimeFormat,
              registrationByDayName: children.name
                ? children.name === ''
                  ? 'Custom'
                  : children.name
                : 'Custom',
              uuid: children.uuid,
              order: children.order,
              qualifyFee: children.qualifyingClass?.price ?? null,
              qualifyFeeName: children.qualifyingClass?.name || null,
            })) ?? [],
        })
      })
    } catch (error) {
      helpers.logger({
        message: error,
      })
    } finally {
      return registerTabData_
    }
  }

  function getTicketTabData(publishedEventInDb_: IEventReviewPublish | null) {
    let ticketTabData_: IRegistrationTabs['ITicketTab'][] = []

    try {
      const { emptyVarName, emptyVarValue } = helpers.findEmptyVal({
        publishedEventInDb_,
        EventTickets: publishedEventInDb_?.EventTickets ?? null,
      })

      if (emptyVarName)
        throw CustomError.somethingWentWrong({
          ...customErrorProps,
          moduleName: 'getTicketTabData',
          devMessage: `${emptyVarName} is [${emptyVarValue}]`,
        })

      const { EventTickets } = publishedEventInDb_ as IEventReviewPublish
      const { tickets, sellSpectatorTickets } = EventTickets

      if (!sellSpectatorTickets || !tickets?.length) return ticketTabData_

      tickets.forEach((ticketItemId) => {
        ticketTabData_.push({
          ticketItemId: ticketItemId.uuid,
          available: ticketItemId.available,
          ticketPrice: ticketItemId.cost,
          ticketTitle: ticketItemId.name,
          ticketDescription: ticketItemId.note,
          registrationTicket: null,
        })
      })
    } catch (error) {
      helpers.logger({
        message: error,
      })
    } finally {
      return ticketTabData_
    }
  }

  async function getPublishedEventFromDb() {
    let publishedEventInDb_: IEventReviewPublish | null = null

    try {
      const publishedEventInDbSnapShot = await FirestoreService.getItem(
        COLLECTIONS.EVENT_REVIEW_PUBLISH.NAME,
        eventId
      )

      if (publishedEventInDbSnapShot.exists())
        publishedEventInDb_ = getConvertedData(
          EventReviewPublishModel.fromFirestoreDoc(publishedEventInDbSnapShot).toObject()
        )
    } catch (error) {
      helpers.logger({
        message: error,
      })
    } finally {
      return publishedEventInDb_
    }
  }

  async function getRegistrationsByDayFromDb(registrationId: string) {
    let registrationsByDay_: IRegistrationByDayInterface[] = []

    try {
      const registrationByDaySnapShots = await FirestoreService.filterItems(
        COLLECTIONS.REGISTRATION_BY_DAY.NAME,
        [
          where(
            COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.REGISTRATION_DOC_ID.KEY,
            '==',
            registrationId
          ),
        ]
      )

      registrationByDaySnapShots.forEach((currDoc) => {
        registrationsByDay_.push(
          getConvertedData(RegistrationByDayModel.fromFirestoreDoc(currDoc).toObject())
        )
      })
    } catch (error) {
      helpers.logger({
        message: error,
      })
    } finally {
      return registrationsByDay_
    }
  }

  async function getRegistrationFromDb() {
    let queries = getBasicQueries()
    let registration: null | TEventRegisteredUsers = null

    try {
      const registrationSnapShots = await FirestoreService.filterItems(
        COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
        queries,
        1
      )

      if (registrationSnapShots.size)
        registration = getConvertedData(
          EventRegisteredUsersModel.fromFirestoreDoc(registrationSnapShots.docs[0]).toObject()
        )
    } catch (error) {
      console.error(error, 'error')
    } finally {
      return registration
    }
  }

  return {
    createRegistration,
  }
}

export default useEventRegistrationTabs
